import "./Home.css";
import React, { useEffect, useState } from "react";
import { generateID } from "../../helpers/widgetsCharts";
import DashboardSelector from "../../components/Home/DashboardSelector";
import TemplatesSelect from "../../components/Home/TemplatesSelect";
import FilterComponent from "../../components/Home/FilterComponent/FilterComponent";
import { format, isValid, startOfMonth, subYears } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../redux/apiCalls/dataCall";
import { applyFilters } from "../../helpers/functions";
import { FaSync } from "react-icons/fa";

function Home() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const data = useSelector((state) => state.data.currentData);
  const [boardSelected, setBoardSelected] = useState(["board1"]);
  const [board, setBoard] = useState({
    board1: [
      {
        template: "templateA",
        id_widget: generateID(),
        board: "board1",
        class: [],
        date: [],
        provinces: [],
        companies: [],
        utilities: [],
      },
    ],
  });

  const [filterOptions, setFilterOptions] = useState({
    date: [],
    provinces: [],
    companies: [],
    utilities: [],
    class: [],
  });

  const [filterClass, setFilterClass] = useState({
    class: [],
  });
  const [filteredData, setFilteredData] = useState([]);
  const [reloadTrigger, setReloadTrigger] = useState(false);

  // Este es tu useEffect original, ahora con la dependencia de reloadTrigger
  useEffect(() => {
    if (reloadTrigger) {
      getData(dispatch, user?.accessToken, {
        startDate: filterOptions.startDate,
        endDate: filterOptions.endDate,
        provinces: [],
        companies: [],
        utilities: [],
        class: [],
      }).then((res) => {
        applyFilters(filterOptions, filterClass, res, setFilteredData);
      });
    }
  }, [reloadTrigger]); // Añadir reloadTrigger como dependencia

  const addImageToBoard = (templateName) => {
    let addTemplate = {
      template: templateName,
      id_widget: generateID(),
      board: boardSelected[0],
      class: filterClass.class,
      ...filterOptions,
    };
    setBoard((prevBoard) => {
      const newBoard = { ...prevBoard };
      const boardName = boardSelected;
      newBoard[boardName] = [addTemplate];

      return newBoard;
    });
  };

  useEffect(() => {
    const currentDate = new Date();
    if (isValid(currentDate) && !data) {
      const oneYearAgoSameMonth = subYears(currentDate, 1);
      const startDate = startOfMonth(oneYearAgoSameMonth);

      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(currentDate, "yyyy-MM-dd");


      setFilterOptions({
        ...filterOptions,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });
      localStorage.setItem(
        "SelectDates",
        JSON.stringify({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        })
      );
    }
  }, []);

  return (
    <div className="">
      <div className="cont-home">
        <div className="parent">
          <div className="div1">
            <TemplatesSelect addImageToBoard={addImageToBoard} />
          </div>
          <div className="dash">
            <ul className="cont-nav">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" type="input">
                  Escritorio
                </a>
              </li>
              <li className="nav-item">
                <div className="div1Contents">
                  <TemplatesSelect addImageToBoard={addImageToBoard} />
                </div>
                <FilterComponent
                  board={board}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                  filterClass={filterClass}
                  setFilterClass={setFilterClass}
                />
              </li>
              <li className="nav-item">
                <button
                  title="Actualizar datos escritorio"
                  onClick={() => setReloadTrigger((prev) => !prev)} // Cambia el estado para forzar el useEffect
                  className="btn-reload"
                >
                  <FaSync />
                </button>
              </li>
              <li className="nav-item dropdown"></li>
            </ul>
            <div className="cont-dashselector">
              <DashboardSelector
                board={board}
                filterOptions={filterOptions}
                boardSelected={boardSelected}
                filterClass={filterClass}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
